import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    close_button: ['close - button'],
    button: ['cta - button']
  }
};

const CardModalTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        background: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          paddingTop: '150px'
        }}
      >
        <div>
          <EditTracking
            value={tracking?.close_button?.[0]}
            type="close_button"
          />
        </div>
        <div>
          <EditTracking value={tracking?.button?.[0]} type="button" />
        </div>
      </div>
    </div>
  );
};

export default CardModalTracking;
